"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = forwardRef;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

const _excluded = ["forwardRef"];

function forwardRef(Component) {
  class ForwardRef extends _react.default.Component {
    render() {
      const _this$props = this.props,
            {
        forwardRef
      } = _this$props,
            rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
        forwardRef: forwardRef
      }, rest));
    }

  }

  const forwardRefFunc = (props, ref) => /*#__PURE__*/_react.default.createElement(ForwardRef, (0, _extends2.default)({}, props, {
    forwardRef: ref
  }));

  const name = Component.displayName || Component.name;
  forwardRef.displayName = `ForwardRef(${name})`;
  return _react.default.forwardRef(forwardRefFunc);
}